export default () => ({
  statusAgenda: null,
  show: false,
  wasRaised: false,
  beenUpdated: false,
  entity: 'lock',
  entities: 'locks',
  includes: ['type', 'professional'],
  locks: [],
  lock: {
    lock_type_id: null,
    professional_id: null,
    name: null,
    date_start: null,
    date_end: null,
    time_start: null,
    time_end: null
  },
  errors: {

  },
  nextStepButtonsRules: [
    {
      icon: '',
      text: 'Cadastrar Regra',
      name: 'professional.agenda.rules.index'
    }
  ],
  prefixRouter: 'professional.agenda.locks'
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/resources/data.js